import { render, staticRenderFns } from "./RegistrationPage.vue?vue&type=template&id=fe17ac1e&scoped=true&"
import script from "./RegistrationPage.vue?vue&type=script&lang=js&"
export * from "./RegistrationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe17ac1e",
  null
  
)

export default component.exports